import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import React from 'react';

export function useVersionListAndSelectedName() {
  const versionList = useDocsDataModelStore((x) => x.versionList);
  const currentName = React.useMemo(() => {
    return versionList.find((x) => x.selected)?.name;
  }, [versionList]);

  return React.useMemo(() => {
    if (versionList.length <= 1 || !currentName) {
      return undefined;
    }

    return {
      versionList,
      currentName,
    };
  }, [currentName, versionList]);
}
